import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/mixpanel"

// Project Settings → "Show the Set up your project guide in the top bar"
// (Kloepfer K8-9; Phelipe 2026-10-09: "if I hide the guide allow me to show it
// again"). Ticking the box asks the server for the label and the pop-up and
// puts them straight back into the page (no reload); unticking hides them the
// way Hide this guide does. Hide this guide inside the pop-up unticks the box
// through the setup-guide:hidden event.
export default class extends Controller {
  static targets = ["box"]
  static values = { showUrl: String, hideUrl: String, projectId: Number, messages: Object }

  connect() {
    this._onHidden = () => { if (this.hasBoxTarget) this.boxTarget.checked = false }
    window.addEventListener("setup-guide:hidden", this._onHidden)
  }

  disconnect() {
    window.removeEventListener("setup-guide:hidden", this._onHidden)
  }

  async toggle() {
    const box = this.boxTarget
    box.disabled = true
    try {
      if (box.checked) await this._show()
      else await this._hide()
    } catch (_) {
      box.checked = !box.checked
      this._toast(this.messagesValue.failed, "error")
    } finally {
      box.disabled = false
    }
  }

  async _show() {
    const data = await (await this._post(this.showUrlValue)).json()
    if (data.shown) {
      const slot = document.getElementById("setupGuideSlot")
      const modalSlot = document.getElementById("setupGuideModalSlot")
      if (slot) slot.innerHTML = data.pill || ""
      if (modalSlot) modalSlot.innerHTML = data.modal || ""
      this._toast(this.messagesValue.shown)
    } else {
      this._toast(this.messagesValue.all_done)
    }
    track("Project Setup Guide Shown Again", { project_id: this.projectIdValue, source: "project_settings" })
  }

  async _hide() {
    const count = document.querySelector("#setupGuidePill [data-setup-guide-count]")?.textContent || "0"
    await this._post(this.hideUrlValue, { steps_done: parseInt(count, 10) || 0 })
    document.getElementById("setupGuidePill")?.remove()
    document.querySelector('[data-controller="setup-guide"]')?.remove()
    document.body.style.overflow = ""
    this._toast(this.messagesValue.hidden)
    track("Project Setup Guide Hidden", { project_id: this.projectIdValue, source: "project_settings" })
  }

  async _post(url, body = {}) {
    const res = await fetch(url, {
      method: "POST",
      headers: { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "", "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body),
      credentials: "same-origin"
    })
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    return res
  }

  _toast(message, type = "success") {
    if (!message) return
    const cssType = type === "error" ? "alert" : "notice"
    const el = document.createElement("div")
    el.className = `flash-toast-${cssType}`
    el.setAttribute("data-controller", "flash")
    el.setAttribute("data-flash-dismiss-after-value", "5000")
    el.setAttribute("role", "alert")
    const text = document.createElement("div")
    text.className = "flex-1 text-sm"
    text.textContent = message
    el.appendChild(text)
    document.body.prepend(el)
  }
}
